import { render, staticRenderFns } from "./_slot.vue?vue&type=template&id=6dca44ac&lang=pug&"
import script from "./_slot.vue?vue&type=script&lang=js&"
export * from "./_slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports